import BlogItem from '../../blog/item';
import { data } from '../../blog/data';
import { Link } from 'react-router-dom';

const Blog = () =>{
  let i = 0;
  return(
    <div
    className="container-fluid division3"
    id="blog">
      <h1 className="title-responsive text-center">
        recent posts from our blog
      </h1>
      <div className="container division2">
        <div className="row">
          {
            data.map((e) =>(
              i++,
              i <= 3?
              <div className="col-12 col-md-6 col-lg-4 px-1 p-lg-2 p-xl-4">
                <BlogItem
                img={e.thumbnail}
                title={e.title}
                />
              </div>
              :false
            ))
          }
        </div>
        <div className="row justify-content-center mt-5">
          <Link
          className="btn btn-primary btn-lg mt-5"
          to="/blog01">
            View more
          </Link>
        </div>
      </div>
    </div>
  )
}
export default Blog